import { render, staticRenderFns } from "./TableEquipmentReview.vue?vue&type=template&id=6bb9736c"
import script from "./TableEquipmentReview.vue?vue&type=script&lang=js"
export * from "./TableEquipmentReview.vue?vue&type=script&lang=js"
import style0 from "./TableEquipmentReview.vue?vue&type=style&index=0&id=6bb9736c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports